import { z } from 'zod'
import type { UiStrings } from '@/constants/ui-locale'

export const ROLE_VALUES = ['dev', 'pm', 'brse'] as const

type RegisterMessages = Pick<
  UiStrings,
  | 'emailRequired'
  | 'emailInvalid'
  | 'nameRequired'
  | 'nameMinLength'
  | 'passwordRequired'
  | 'passwordMinLength'
  | 'passwordComplexity'
  | 'confirmPasswordRequired'
  | 'roleRequired'
  | 'passwordsMustMatch'
>

export function createRegisterSchema(messages: RegisterMessages) {
  return z
    .object({
      email: z.string().min(1, messages.emailRequired).email(messages.emailInvalid),
      name: z.string().min(1, messages.nameRequired).min(2, messages.nameMinLength),
      password: z
        .string()
        .min(1, messages.passwordRequired)
        .min(8, messages.passwordMinLength)
        .regex(/((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9]))/, messages.passwordComplexity),
      confirmPassword: z.string().min(1, messages.confirmPasswordRequired),
      role: z.enum(ROLE_VALUES, {
        message: messages.roleRequired,
      }),
    })
    .refine((data) => data.password === data.confirmPassword, {
      path: ['confirmPassword'],
      message: messages.passwordsMustMatch,
    })
}

export type RegisterFormValues = z.infer<ReturnType<typeof createRegisterSchema>>
